/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiResultOfMapOfstringAndobject
 */
export interface ApiResultOfMapOfstringAndobject {
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfMapOfstringAndobject
     */
    data?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndobject
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfMapOfstringAndobject
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndobject
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndobject
     */
    result?: ApiResultOfMapOfstringAndobjectResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfMapOfstringAndobjectResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfMapOfstringAndobjectFromJSON(json: any): ApiResultOfMapOfstringAndobject {
    return ApiResultOfMapOfstringAndobjectFromJSONTyped(json, false);
}

export function ApiResultOfMapOfstringAndobjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfMapOfstringAndobject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfMapOfstringAndobjectToJSON(value?: ApiResultOfMapOfstringAndobject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

